import { type WidgetMetadata } from '@examdojo/core/widget';
import { EXPLORATION_PRESET, ROOT_CALCULATION_PRESET, TUTORING_PRESET } from './presets';
import { QuadraticWidgetConfig } from './quadratic-function.model';

/**
 * Capability-focused metadata for the Quadratic Function Widget.
 * Describes what the widget can do; presets provide example configs.
 */
export const QUADRATIC_FUNCTION_METADATA: WidgetMetadata<QuadraticWidgetConfig> = {
  type: 'quadratic-function',
  description: 'Interactive quadratic function y = ax² + bx + c',

  // Mathematical parameters
  parameters: ['a', 'b', 'c'],

  // Display features that can be toggled
  displayFeatures: ['vertex', 'roots', 'axisOfSymmetry', 'yIntercept', 'parabola', 'grid', 'axes'],

  // Actions the widget supports
  supportedActions: [
    'UPDATE_COEFFICIENTS',
    'FIT_TO_PARABOLA',
    'FOCUS_REGION',
    'HIGHLIGHT',
    'RESET_VIEW',
    'TRANSFORM_VIEW',
    'PATCH_STYLE',
  ],

  // Regions that can be focused/zoomed to
  focusableRegions: ['vertex', 'roots', 'axisOfSymmetry', 'yIntercept', 'parabola', 'all'],

  // Object IDs that can be highlighted
  highlightableObjects: ['parabola', 'vertex-point', 'root-1', 'root-2', 'axis-line', 'y-intercept-point'],

  // Presets serve as living documentation of valid configs
  exampleConfigs: [EXPLORATION_PRESET.config, TUTORING_PRESET.config, ROOT_CALCULATION_PRESET.config],
};
